export default __webpack_public_path__ + "static/media/set_expectations_square.acd8fac7.png";